import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";

const state = {
  id: undefined,
  approvalStatus: undefined,
  approvalCurrentStep: undefined,
  approvalTotalStep: undefined,
  createdFormFields: undefined, // []
  approvalSteps: undefined, // []
  currentApprovalStep: undefined, // {}
  author: undefined, // {}
  createdAt: undefined,
  updatedAt: undefined
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
